import { CSTNode } from './CST';
import { Token } from './Token';

export function isToken(node: CSTNode | Token): node is Token {
  return (node as Token).syntaxKind !== undefined;
}

export function isNode(node: CSTNode | Token): node is CSTNode {
  return (node as CSTNode).type !== undefined;
}
